import React, { Component } from 'react';
import {
  Col,
  FormLabel,
  FormControl,
  FormGroup,
  Container,
  ListGroup,
  ListGroupItem,
  Row,
  Tab,
  Tabs,
  Card,
} from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import '../../components/Dealers/Dealers.css';
import Api from '../../api/api';

import { userCanUseTPO, userIsAdmin } from '../../utils/RolesBasedUsers';
import InsufficientPermission from '../../components/Dealers/InsufficientPermission';

let initialState = {};

export class PaymentEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      authToken: localStorage.getItem('authToken'),
      tabKey: 1,
      isBookingIdPresent: false,
      tabLabels: {
        SendPayment: 'Send Payment',
        AttemptDetails: 'Attempt Details',
        OtherDetails: 'Other Details',
      },
      dealerName: props.payment.dealerName,
      locationName: props.payment.locationName,
      bookingId: '',
      payments: props.payment ? [props.payment] : [],
    };
  }

  componentDidMount() {
    const { authToken } = this.state;
    if (!authToken) {
      this.props.history.push({
        pathname: '/sessionexpired',
        state: {
          error: 'Unauthorised or Session Expired',
          error_description: 'Please try to login again',
        },
      });
    } else {
      const obj = document.getElementById('navLoginLogout');
      obj.innerText = 'Logout';
    }
  }

  goBackToPaymentList = () =>
    this.props.history.push({
      pathname: '/dashboard',
      state: { authToken: this.state.authToken },
    });

  saveAndRetry = async () => {
    this.setState({ loading: true });
    try {
      const { payments, bookingId, isBookingIdPresent } = this.state;
      const payload = {
        uuid: payments.length > 0 && payments[0] && payments[0].id ? payments[0].id : '',
      };
      if (isBookingIdPresent) {
        payload.bookingId = bookingId;
        await Api.updateFailedBookingTransactionWithBookingId(payload);
      } else {
        await Api.updateFailedBookingTransaction(payload);
      }
      this.goBackToPaymentList();
    } catch (error) {
      console.error(error);
      this.props.history.push({
        pathname: '/sessionexpired',
        state: { authToken: this.state.authToken },
      });
    }
  };

  handleNewBookingId = event => {
    const bookingId = event.target.value.trim();
    this.setState({
      bookingId,
      isBookingIdPresent: bookingId.length > 0,
    });
  };

  resetForm = () => this.setState(initialState);

  updateOption = (value, event, id) => {
    const { payments } = this.state;
    const featureIndex = payments.findIndex(payment => payment.payment === id);
    payments[featureIndex].value = value;
    this.setState({
      payments: [...payments],
    });
  };

  render() {
    const { isBookingIdPresent, loading } = this.state;
    return (
      <React.Fragment>
        <Tabs
          activeKey={this.state.tab}
          onSelect={this.handleSelect}
          id="toggleLists"
          className="tabsDealer"
        >
          <Tab eventKey={1} title={this.state.tabLabels.SendPayment}>
            {!userIsAdmin() ? (
              <InsufficientPermission />
            ) : (
              <div className="dealerEditWrap">
                <div className="payment-details-wrapper">
                  {this.state.payments && this.state.payments.length > 0 ? (
                    this.state.payments.map((payment, index) => {
                      return (
                        <Card key={payment.id || index} className="payment-detail-card">
                          <Card.Body>
                            {payment && payment.paymentMessageDetails ? (
                              <pre className="preformatted">
                                {JSON.stringify(payment.paymentMessageDetails, null, 2)}
                              </pre>
                            ) : (
                              <span>No payment details available.</span>
                            )}
                          </Card.Body>
                        </Card>
                      );
                    })
                  ) : (
                    <span>No payments available.</span>
                  )}
                </div>
                <Row>
                  <form
                    onSubmit={e => {
                      e.preventDefault();
                    }}
                  >
                    <FormGroup controlId="formBasicText">
                      <FormLabel>
                        {' '}
                        <strong>BookingID *only applicable if changed</strong>
                      </FormLabel>
                      <FormControl
                        type="text"
                        value={this.state.bookingId}
                        placeholder="updated booking id"
                        maxLength="50"
                        onChange={this.handleNewBookingId}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                  </form>
                </Row>

                <Row id="controls" className="dealerEditLowerRow ">
                  <Container className="dealerEditLowerRow">
                    <div className="dealerFeaturesLowerLine" />
                    <Row className="dealerButtons">
                      <Col xs={6}>
                        <button
                          className={`btn ${
                            !this.state.loading ? 'btn-warning' : 'btn-danger'
                          } dealerButton`}
                          onClick={this.resetForm}
                          disabled={loading}
                        >
                          Reset
                        </button>
                      </Col>
                      <Col xs={6}>
                        <button
                          className={`btn ${loading ? 'btn-danger' : 'btn-success'} dealerButton`}
                          disabled={loading}
                          onClick={this.saveAndRetry}
                        >
                          {!loading ? <p>Send Payment</p> : <p>Please wait loading</p>}
                        </button>
                      </Col>
                    </Row>
                  </Container>
                </Row>
              </div>
            )}
          </Tab>

          <Tab eventKey={2} title={this.state.tabLabels.AttemptDetails}>
            {!userIsAdmin() || !userCanUseTPO() ? (
              <InsufficientPermission />
            ) : (
              <div className="attempt-details-wrapper">
                {this.state.payments && this.state.payments.length > 0 ? (
                  this.state.payments.map((payment, index) => {
                    return (
                      <Card key={payment.id || index} className="attempt-detail-card">
                        <Card.Body>
                          {payment && payment.attemptsDetails ? (
                            <pre className="preformatted">
                              {JSON.stringify(payment.attemptsDetails, null, 2)}
                            </pre>
                          ) : (
                            <span>No attempt details available.</span>
                          )}
                        </Card.Body>
                      </Card>
                    );
                  })
                ) : (
                  <span>No payments available.</span>
                )}
              </div>
            )}
          </Tab>

          <Tab eventKey={3} title={this.state.tabLabels.OtherDetails}></Tab>
        </Tabs>
      </React.Fragment>
    );
  }
}

export default withRouter(PaymentEdit);



// WEBPACK FOOTER //
// ./src/containers/PaymentDashboard/PaymentEdit.js